import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customerPartnerFunctions.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customerPartnerFunctions.actionsLoading;
export const getItems = (state:RootState) => state.customerPartnerFunctions.items;
export const getItemsSelect = (state:RootState) => state.customerPartnerFunctions.dropDownItems;
export const getItemsCount = (state:RootState) => state.customerPartnerFunctions.itemsCount;
export const getItemForEdit = (state:RootState) => state.customerPartnerFunctions.itemForEdit;
export const getError = (state:RootState) => state.customerPartnerFunctions.error;
export const getErrorAction = (state:RootState) => state.customerPartnerFunctions.errorAction;
export const validationErrors = (state: RootState) => state.customerPartnerFunctions.validationErrors;
